(function () {
    function initGsWhyAnimation() {
      const sections =
        document.querySelectorAll(
          ".gs-why-section"
        );

      if (!sections.length) {
        return;
      }

      const reducedMotion =
        window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches;

      sections.forEach(function (section) {
        if (
          section.dataset.gsWhyReady ===
          "true"
        ) {
          return;
        }

        section.dataset.gsWhyReady =
          "true";

        if (reducedMotion) {
          section.classList.add(
            "is-visible"
          );
          return;
        }

        section.classList.add(
          "gs-why-animate-ready"
        );

        if (
          !("IntersectionObserver" in window)
        ) {
          section.classList.add(
            "is-visible"
          );
          return;
        }

        const observer =
          new IntersectionObserver(
            function (
              entries,
              currentObserver
            ) {
              entries.forEach(
                function (entry) {
                  if (
                    entry.isIntersecting
                  ) {
                    entry.target.classList.add(
                      "is-visible"
                    );

                    currentObserver.unobserve(
                      entry.target
                    );
                  }
                }
              );
            },
            {
              threshold:
                0.16,

              rootMargin:
                "0px 0px -6% 0px"
            }
          );

        observer.observe(
          section
        );
      });
    }

    if (
      document.readyState ===
      "loading"
    ) {
      document.addEventListener(
        "DOMContentLoaded",
        initGsWhyAnimation
      );
    } else {
      initGsWhyAnimation();
    }

    document.addEventListener(
      "shopify:section:load",
      initGsWhyAnimation
    );
  })();
